export let group = '';
export let kompetenzenAvailable = [];
export let kompetenzenSelected = [];
let INITIAL_SHOWING = 8;
let MAX_SHOWING = INITIAL_SHOWING;
let INCREMENT = 8;
export class ReferenzSuche {

  static init() {

    group = $('.menu__kompetenzen-gruppen__item.active').first().data('name');
    $(`#${group} > .menu__kompetenzen__group__item`).each((index, element) => kompetenzenAvailable.push($(element).data('name')));
    kompetenzenSelected = kompetenzenAvailable;

    this.updateList(null);

    $('.menu__kompetenzen-gruppen__item').click((event) => {
      this.updateMenu(event);
      this.updateList(event);
    });

    $('.menu__kompetenzen__group__item').click((event) => {
      $('.menu__kompetenzen__group__item').removeClass('active');
      $(event.currentTarget).addClass('active');

      const kompetenzId = $(event.currentTarget).data('name');
      kompetenzenSelected = kompetenzenAvailable.filter((kompetenz) => kompetenz === kompetenzId);

      this.updateList(event);
    });

    $('.referenzen__list__item__show-all_btn').click((event) => {
      MAX_SHOWING += INCREMENT;
      this.updateList();
    });
  }


  static updateMenu(event) {
    const kompetenzGruppenId = $(event.currentTarget).data('name');
    group = kompetenzGruppenId;

    kompetenzenAvailable = [];
    $(`#${kompetenzGruppenId} > .menu__kompetenzen__group__item`)
      .each((index, element) => kompetenzenAvailable.push($(element).data('name')));
    kompetenzenSelected = kompetenzenAvailable;

    $('.menu__kompetenzen-gruppen__item').removeClass('active');
    $(event.currentTarget).addClass('active');

    $('.menu__kompetenzen__group').addClass('hidden');
    $(`#${kompetenzGruppenId}`).removeClass('hidden');

    $('.menu__kompetenzen__group__item').removeClass('active');

    MAX_SHOWING = INITIAL_SHOWING;

  }


  static updateList() {

    const referenzen = $('.referenzen__list > .referenzen__list__item').toArray();
    let referenzenCount = 0;

    referenzen.forEach((element) => {
      const itemKompetenzen = $(element).data('kompetenzen').trim().split(',');
      const qualifiesToBeShown = kompetenzenSelected.some((kompetenz) => itemKompetenzen.includes(kompetenz));
      const hiddenDueToShowAll = referenzenCount >= MAX_SHOWING;
      if (qualifiesToBeShown && !hiddenDueToShowAll) {
        if ($(element).hasClass('hidden')) {
          $(element).removeClass('hidden');
        }
        referenzenCount++;
      } else if (!$(element).hasClass('hidden')) {
        $(element).addClass('hidden');
      }
    });

    if (referenzenCount === 0) {
      $('.referenzen__list__item__empty').show();
    } else {
      $('.referenzen__list__item__empty').hide();
    }

    if (MAX_SHOWING > referenzenCount) {
      $('.referenzen__list__item__show-all').hide();
    } else {
      $('.referenzen__list__item__show-all').show();
    }
  }
}
